export default {
  cash: {
    id: "o-type-payment-cash",
    title: "Наличными в магазине",
    value: "cash",
  },
  shopCard: {
    id: "o-type-payment-card",
    title: "Оплатить банковской картой в магазине",
    value: "shop_card",
  },
  onlineCard: {
    id: "o-type-payment-online",
    title: "Оплатить банковской картой онлайн",
    value: "online_card",
  },
  bill: {
    id: "o-type-payment-bill",
    title: "счет",
    value: "bill",
  },
  sbp: {
    id: "o-type-payment-sbp",
    title: "СБП",
    value: "sbp",
  },
};
